import { api } from '@marketplace-web/core-api/core-api-client-util'

export const markAsUnreserved = ({ itemId }: { itemId: number }) =>
  api.delete(`items/${itemId}/reservation`)
